import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import get from 'lodash/get';
export default {
  name: 'CoreTwoFactorAuthModalDisable',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVerifyToken: '',
      errorVerify: false
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  watch: {
    isOpen(value) {
      if (value) {
        this.resetModal();
      }
    }
  },
  methods: {
    get,
    resetModal() {
      this.errorVerify = false;
      this.inputVerifyToken = '';
    },
    handleCodeEntered() {
      const userid = get(this, '$store.state.authentication.user.id') || null;
      ApiService.disableTwoFactorAuth(userid, this.inputVerifyToken).then(() => {
        this.$emit('disabled');
        this.$emit('close');
      }).catch(() => {
        this.errorVerify = true;
      });
    }
  }
};